module.exports = __webpack_public_path__ + "img/1440.f34a3c0b.jpg";